import { useEffect, useState } from "react";
import { scrollToSection } from "@/App";
import { useContent } from "@/context/ContentContext";

const LINKS = [
  { id: "trattoria", label: "La Trattoria" },
  { id: "galleria", label: "Galleria" },
  { id: "contatti", label: "Orari & Contatti" },
];

export default function Navbar() {
  const { site } = useContent();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-sand-50/80 border-b border-stone-200/50"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-terracotta-500"
        >
          <span className="w-11 h-11 rounded-full overflow-hidden bg-sand-50 border border-stone-200/60 shrink-0">
            <img src="/logo.png" alt={`Logo ${site.name}`} className="w-full h-full object-cover" />
          </span>
          <span
            className={`font-serif text-2xl tracking-tight transition-colors duration-500 ${
              scrolled ? "text-olive-900" : "text-sand-50"
            }`}
          >
            {site.name}
          </span>
        </button>
        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((link) => (
            <button
              key={link.id}
              data-testid={`nav-link-${link.id}`}
              onClick={() => scrollToSection(link.id)}
              className={`text-xs font-medium tracking-[0.18em] uppercase transition-colors duration-300 hover:text-terracotta-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-terracotta-500 ${
                scrolled ? "text-stone-700" : "text-sand-50/90"
              }`}
            >
              {link.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-preventivi"
            onClick={() => scrollToSection("preventivi")}
            className={`text-xs font-medium tracking-[0.18em] uppercase px-6 py-3 border transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-terracotta-500 ${
              scrolled
                ? "border-olive-900 text-olive-900 hover:bg-olive-900 hover:text-sand-50"
                : "border-sand-50/80 text-sand-50 hover:bg-sand-50 hover:text-olive-900"
            }`}
          >
            Preventivi
          </button>
        </nav>
        <button
          data-testid="nav-cta-preventivi-mobile"
          onClick={() => scrollToSection("preventivi")}
          className={`md:hidden text-xs font-medium tracking-[0.18em] uppercase px-5 py-2.5 border transition-colors duration-300 ${
            scrolled
              ? "border-olive-900 text-olive-900"
              : "border-sand-50/80 text-sand-50"
          }`}
        >
          Preventivi
        </button>
      </div>
    </header>
  );
}
